<template>
  <div id="app-backdrop" :class="{ 'no-display': !hasDisplay }">
    <Transition appear>
      <div
        v-if="hasDisplay"
        :key="route.name as string"
        :class="['backdrop-wrapper', { 'no-display': !hasDisplay }]"
      >
        <div class="backdrop-image" :style="{ background: backdropImage }" />
        <div class="backdrop-color" :style="{ background: backdropColor }" />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const backdropColor = ref('');
const backdropImage = ref('');

const hasDisplay = computed(() => !!backdropColor.value || !!backdropImage.value);

watch(
  () => route.meta,
  (meta) => {
    backdropColor.value = (meta?.backdropColor as string) || '';
    backdropImage.value = meta?.backdropImage
      ? `url(${meta.backdropImage})`
      : '';
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped>
#app-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  right: 0;
}

.backdrop-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 1;
  transition: opacity 0.5s;
  z-index: 2;

  .no-display & {
    transition: 0s !important;
    background: red;
    opacity: 0;
  }

  &.v-enter-from {
    opacity: 0;
  }

  &.v-leave-from,
  &.v-leave-active {
    transition: opacity 1s;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 190px;
    right: 0;
    background: linear-gradient(#3f0598a1, transparent);
    z-index: 4;
  }
}

.backdrop-image,
.backdrop-color {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: cover !important;
  background-position: center !important;
}

.backdrop-image {
  z-index: 4;
  opacity: 0.5;

  &.v-leave-active {
    z-index: 2;
  }
}

.backdrop-color {
  z-index: 3;
  opacity: 1;

  &.v-leave-active {
    z-index: 2;
  }
}
</style>
